import {
  ApolloLogo,
  CronometerLogo,
  MyFitnessPalLogo,
} from '@jouzen/ecom-components';
import type { SVGIconComponent } from 'types/svgr';

import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

const SleepAndRestIntegrations = (): JSX.Element => {
  return (
    <section data-cy="sleep-and-rest-integrations" className="py-16">
      <LandingPageIntegrations
        description="sleep_and_rest_integrations_description"
        logoColor="white"
        integrations={[
          {
            description: 'sleep_and_rest_integrations_myfitnesspal',
            Logo: MyFitnessPalLogo as SVGIconComponent,
            name: 'myfitnesspal',
          },
          {
            description: 'sleep_and_rest_integrations_cronometer',
            Logo: CronometerLogo as SVGIconComponent,
            name: 'cronometer',
          },
          {
            description: 'sleep_and_rest_integrations_apollo',
            Logo: ApolloLogo as SVGIconComponent,
            name: 'apollo',
          },
        ]}
        inverted
        title="sleep_and_rest_integrations_title"
      />
    </section>
  );
};

export default SleepAndRestIntegrations;
